import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ChevronsLeft, ChevronsRight } from 'react-feather';
import Button, { ButtonSizes, ButtonTypes } from '../../button';
import Tooltip from '../../tooltip/tooltip';
import Icon, { IconColors } from '../../icon';
import useTranslation from '../../../../utils/translation-utils';

const ScrollTableButton = ({
  disabled, onClick, isRightScrolled,
}) => {
  const [getTranslation] = useTranslation();
  const description = isRightScrolled ? getTranslation('SCROLL_TO_LEFT')
    : getTranslation('SCROLL_TO_RIGHT');

  return (
    <Tooltip description={description}>
      <Button
        borderLess
        onClick={onClick}
        disabled={disabled}
        className="ccb-cont"
        type={ButtonTypes.SECONDARY}
        size={ButtonSizes.SMALL}
        renderIcon={({ size }) => (
          <Icon
            size={size}
            icon={isRightScrolled ? ChevronsLeft : ChevronsRight}
            color={disabled ? IconColors.DISABLED : IconColors.GREY}
          />
        )}
      />
    </Tooltip>
  );
};

ScrollTableButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  isRightScrolled: false,
};

ScrollTableButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isRightScrolled: PropTypes.bool,
};

export default memo(ScrollTableButton);
